import { stytch } from '@/modules/auth/stytchClient';

/**
 * Current Stytch session JWT for Bearer auth (non-React modules).
 */
export function getSessionAccessToken() {
  try {
    const tokens = stytch.session.getTokens?.();
    if (tokens?.session_jwt) return tokens.session_jwt;
    return null;
  } catch {
    return null;
  }
}

export async function requireSessionAccessToken() {
  const token = getSessionAccessToken();
  if (!token) {
    throw new Error('No valid session available');
  }
  return token;
}
